<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    <span>Home</span>
                    &#8226; <span>OpenSearch</span>
                </template>
            </ui-breadcrumbs>
        </template>
    </panel-template>
</template>

<script>
    import PanelTemplate from '@/templates/page-panel-center'
    import { uiBreadcrumbs } from "@/components/ui"
    import helpers from '@/mixins/helpers'

	import { storage } from '@/services/storage'

    export default {
        props: {
            query: {
                type: String,
                required: true
            }
        },

        mixins: [ helpers ],

        components: {
            PanelTemplate,
            uiBreadcrumbs
        },

		data() {
			return {
				getUser: null,
				betaFeatures: null
			}
		},

		computed: {
			isDynamicUser() {
				return (this.getUser && this.getUser.isDynamicGroup) ? true : false
			},

			openSearchAllowed() {
				return (
					this.betaFeatures && 
						this.betaFeatures.opensearch && 
							this.betaFeatures.opensearch[this.getUser.user_group] == 1) || (this.isDynamicUser && this.betaFeatures.opensearch['dynamic'] == 1)
			}
		},

		created(){
			this.getUser = JSON.parse(storage.get('user_logged'))
			this.betaFeatures = JSON.parse(storage.get('beta_features'))
		},

        mounted() {
			// Prevent unauthorized users
			if (!this.openSearchAllowed) {
				this.$router.push("/nao-autorizado")
				return
			}

            if (this.query) {
                let search = this.query.replace("-", " ")
                this.$store.dispatch('openSearch/setQuery', search, this.getInstance())
                this.$store.dispatch('openSearch/setRedirect', true)

            } else {
                this.$toastr.e('Nenhum termo de busca foi informado.')
                this.$router.go(-1)
            }
        }
    }
</script>

<style lang='stylus' scoped>
    @import './styles.styl'
</style>
